<div class="hint" *ngIf="timeline && !timeline.length">No timeline available for {{ performer?.name || exhibitor?.name || resource?.name || attendee?.name || 'brief' }}</div>
<expanding-wrapper
  *ngIf="!timeline || timeline.length"
  [initOpen]="standalone"
  [manualToggle]="standalone"
  [hideArrow]="standalone"
  [hideTitleOnExpand]="standalone"
  [title]="'My Schedule'"
  [borderGreyOnCollapse]="true"
>
  <add-to-cal class="header-right" *ngIf="!standalone && timeline.length && shareCode && (!!performer || !!exhibitor || !!resource)" [canSubscribe]="true" [title]="eventTitle" [eventId]="eventId" [buttonView]="true" [shareCode]="shareCode" [entityType]="!!performer ? 'performer' : !!exhibitor ? 'exhibitor' : !!attendee ? 'attendee' : 'resource'" [entityId]="performer?.id || exhibitor?.id || resource?.id" ></add-to-cal>

  <shared-timeline-wrapper
    [loading]="!timeline"
    [madeWithJoi]="!standalone"
    [unavailable]="unavailable">
    <div class="single-timeline" *ngFor="let dayTimeline of timeline; trackBy: trackByDate">
      <h3 class="group_date" *ngIf="dayTimeline.date">
        <span *ngIf="!dayTimeline.dayDate">{{ dayTimeline.dateId | customDate | date:"EEEE d LLLL y" }}</span>
        <span *ngIf="dayTimeline.dayDate">{{ dayTimeline.dayDate }}</span>
      </h3>
      <single-timeline 
        [link]="false"
        [brief]="true"
        [condensedPerformers]="false"
        [collapseByDefault]="true"
        [singleTimeline]="dayTimeline"
        [performers]="performers"
        [performer]="performer"
        [labelMaps]="labelMaps"
        [performerRoles]="performerRoles"
        [sponsors]="sponsors"
        [sponsorTypes]="sponsorTypes"
        [publicView]="publicView"
        [venues]="venues"
        [showActivityStatus]="showActivityStatus">
      </single-timeline>
    </div>
  </shared-timeline-wrapper>
</expanding-wrapper>